module.exports = __webpack_public_path__ + "img/alert-red.f6aba11e.svg";